"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.Dimmer = void 0;
require("./Dimmer.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Dimmer component
 *
 * A semi-transparent overlay that covers the entire viewport,
 * typically used as a backdrop for modals, dialogs, and other overlay UI patterns.
 *
 * @method
 * @param {DimmerProps} props - React properties passed from composition
 * @param {React.Ref} ref - Forwarded ref to the underlying div element
 * @returns Dimmer
 */
const Dimmer = exports.Dimmer = (0, _react.forwardRef)((props, ref) => {
  const {
    className,
    onClick,
    zIndex = defaultProps.zIndex,
    ...rest
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-Dimmer', {
    [`${className}`]: className
  });
  const containerStyle = {
    '--zIndex': zIndex
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    "aria-hidden": "true",
    className: componentClassName,
    onClick: onClick,
    ref: ref,
    role: "presentation",
    style: containerStyle
  }, rest));
});
Dimmer.displayName = 'Dimmer';

/**
 * Property type definitions
 * @typedef DimmerProps
 * @type {object}
 * @property {string} className - Additional CSS class names to apply
 * @property {func} onClick - Callback function when dimmer is clicked
 * @property {number} zIndex - Sets the z-index of the Dimmer overlay
 */
const propTypes = exports.propTypes = {
  /**
   * Additional CSS class names to apply
   */
  className: _propTypes.default.string,
  /**
   * Callback function when dimmer is clicked
   */
  onClick: _propTypes.default.func,
  /**
   * Sets the z-index of the Dimmer overlay
   */
  zIndex: _propTypes.default.number
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {number} zIndex - 6 - Sets the default z-index to 6
 */
const defaultProps = exports.defaultProps = {
  zIndex: 6
};
Dimmer.propTypes = propTypes;
Dimmer.defaultProps = defaultProps;
var _default = exports.default = Dimmer;